import { createSelector } from 'reselect';
import _ from 'lodash';

import { NO_TICKET_TYPE_ID_FOR_TURN } from 'constants/TableBasedTemplatesConstants';
import { StoreType } from '@tock/shared/utils/connect';
import { dashboard } from 'types';

export const serviceDayTurnTimesByTicketTypeSelector = createSelector(
  (state: StoreType) => state.turnTimes.serviceTurnTimes,
  (turnTimes): { [ticketTypeId: string]: dashboard.TurnTime[] } => {
    return _.groupBy(turnTimes, (turnTime) => turnTime.ticketTypeId || NO_TICKET_TYPE_ID_FOR_TURN);
  }
);

export const globalTurnTimesByTicketTypeSelector = createSelector(
  (state: StoreType) => state.turnTimes.turnTimes,
  (turnTimes): { [ticketTypeId: string]: dashboard.TurnTime[] } => {
    return _.groupBy(turnTimes, (turnTime) => turnTime.ticketTypeId || NO_TICKET_TYPE_ID_FOR_TURN);
  }
);
